<template>
	<div id="app">
		<!-- <img alt="Vue logo" src="./assets/logo.png"> -->
		<router-view />
	</div>
</template>

<script>

export default {
	name: 'App',

}
</script>

<style lang="scss">
  @import './styles/iconfont.css';
  .el-avatar{
	background: url('./assets/avatar1.png') center center  transparent;
	background-size: 100%;
  }
/* 充值 头部样式 */
.header {
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	background: linear-gradient(135deg, #3f8de2 0%, #3f8de2 100%);
	padding: 10px 0;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

	z-index: 1000;
}

.header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: white;
	width: 85%;
	margin: 0 auto;
	padding: 0 15px;
}

/* 全局样式 */
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	font-family:PingFang SC,Source Han Sans CN,Microsoft YaHei,Heiti SC,tahoma,arial,Hiragino Sans GB,"\5B8B\4F53",sans-serif;
	color: #333;

}

.showLoginOut .el-button--text {
	color: #fff;
}

.content-container {
	width: 98%;
	margin: 20px auto;
	max-width: 1200px;
}

.mes-el-popover {
	padding: 0;
}
.com-dialog{
  max-width: 500px;
  width: 90% !important; // 移动端自适应
}
 
.container {
  max-width: 1216.0px;
  margin: 0 auto;
}
.el-button--primary{
	background: linear-gradient(270deg, #0062DF 0%, #5CA3FF 99%);
}
</style>
